// extracted by mini-css-extract-plugin
export default {"wrapper":"Oy-z","viewport":"Py-z","container":"Qy-z","slide":"Ry-z"};